<template>
	<div class="sv-checkbox">
		<label>
			<input type="checkbox" v-model="isChecked" @change="onChange">
			<span class="horizontal-center"><slot></slot></span>
		</label>
	</div>
</template>

<script>

export default {
	name: 'SvCheckbox',
	props: {
		value: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isChecked: false,
		}
	},
	mounted() {
	},
	watch: {
		value: function() {
			this.isChecked = this.value;
		}
	},
	computed: {
	},
	methods: {
		onChange: function() {
			this.$emit('input', this.isChecked);
		},
	},
}
</script>

<style lang="scss">

</style>
